const MODULE_ID = 'gallery';
export default MODULE_ID;
